/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './RadioInput.scss'
import React from 'react'
import RadioGroupContext from './RadioGroupContext'
import uuid from 'shortid'

function RadioGroup(props) {
  const uniq = uuid.generate()
  const nameValue = props.name + '_' + uniq
  const inputValue = props.value || ''

  return (
    <RadioGroupContext.Provider
      value={{
        name: props.name,
        nameUniqueValue: nameValue,
        inputValue: inputValue
      }}
    >
      {props.children}
    </RadioGroupContext.Provider>
  )
}

export default RadioGroup
